var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 720,
    height: 480,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D21034",
    d: "M0 0h720v480H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#007E3A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 120h480v240H120z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 390,
    cy: 240,
    r: 80
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 240,
    r: 80
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMv);
export default __webpack_public_path__ + "static/media/mv.ca07341645d4b22e4ea471a03a22ce60.svg";
export { ForwardRef as ReactComponent };